import Axios from '../../utils/axios';
import { getBackendErrorMessage } from '../../utils/errorHandler';

export interface Pitstop {
  id: number;
  ID?: number;
  name: string;
  address?: string;
  city: {
    id: number;
    name: string;
    code: string;
    uuid: string;
    province_id: number;
    is_active: boolean;
    created_at: string;
    timezone: string;
    google_place_id: string;
    wilayahid_code: string;
  };
  cityID?: number;
  cityName?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface PitstopListResponse {
  data: Pitstop[];
  pagination: {
    total: number;
    page: number;
    size: number;
    lastPage: number;
  };
}

export const getListPitstop = async (params: {
  page?: string;
  size?: string;
  search?: string;
  type?: string;
  hasStaff?: boolean;
  providerID?: number;
}): Promise<PitstopListResponse> => {
  try {
    const response = await Axios.get('/v1/pitstop', { params });
    return response.data;
  } catch (error) {
    throw new Error(getBackendErrorMessage(error));
  }
};
